/*@flow*/

export default function getToken(): string {
  let metaTag: ?HTMLMetaElement;
  if (document) {
    metaTag = Array.from(document.getElementsByTagName('meta')).filter(
      o => o.name === 'csrf-token'
    )[0];
  }

  let token = '';

  if (metaTag) {
    token = metaTag.content;
  }

  return token;
}
